// extracted by mini-css-extract-plugin
module.exports = {"link":"style__link__iw810"};